import { camelCase, mapKeys } from 'lodash';
import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import serverService from 'api/services/server.service';

import { APIKeys } from 'common/enum/api-keys.enum';

export const useFeatures = () => {
  const { data, refetch, isFetching } = useQuery<Record<string, any>>({
    placeholderData: {},
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: [APIKeys.FEATURES],
  });

  const fetchData = async (): Promise<Record<string, any>> => {
    try {
      const features = await serverService.getFeatures();
      const formattedFeatures = mapKeys(features, (_, key) => camelCase(key));

      return formattedFeatures;
    } catch (error) {
      toastError('Failed to fetch system features', error);

      throw error;
    }
  };

  return { data, refetch, isLoading: isFetching };
};
